module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/leader-f5e23c69779a7d646ca9b26a6ae7f359.svg";